<script>
  import { onMount, beforeUpdate } from 'svelte'
  export let title = 'Default title'
  export let color = 'dark'
  let heading
</script>

<div class="title-line {color}" />
<h1 bind:this={heading} class={color}>{title}</h1>

<style lang="scss">
  @import '../responsive.scss';

  .title-line {
    width: 100%;
    height: 30px;
    &.light {
      background-color: var(--light);
    }
    &.dark {
      background-color: var(--dark);
    }

    @include for-tablet {
      height: 20px;
    }
  }

  h1 {
    font-family: 'Arteria-Bold';
    font-size: 6em;
    line-height: 1em;
    margin-bottom: 40px;
    &.light {
      color: var(--light);
    }
    &.dark {
      color: var(--dark);
    }

    @include for-tablet {
      font-size: 4rem;
    }

    @include for-tablet-p {
      margin-bottom: 20px;
    }

    @include for-phone {
      font-size: 3rem;
    }
  }
</style>
